module.exports = __webpack_public_path__ + "img/thumb_18.20936dd6.jpg";